import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Categories } from 'constants/analytics'
import events, { Event } from 'pubsub/events'
import getSubdomain from '../../utils/getSubdomain'

import MedicareLogo from '../MedicareLogo/MedicareLogo'
import { GovBanner } from '../GovBanner/GovBanner'

export interface GovAndMenuWrapperProps {
  languageToggleLink: string;
  children: React.ReactNode;
  isLoggedIn: boolean;
}

export const GovAndMenuWrapper: React.FC<GovAndMenuWrapperProps> = ({ children, languageToggleLink, isLoggedIn }) => {
  const { i18n } = useTranslation()
  const lang = (i18n.language === 'es') ? 'es' : 'en'

  const ignoredSubdomain = lang === 'es' ? 'www' : undefined
  const medicareEnv = process.env.REACT_APP_MEDICARE_ENV || ''
  const medicareSubdomain = getSubdomain(medicareEnv, ignoredSubdomain)
  const langSubdomain = getSubdomain(lang, 'en')

  const medicareUrl = `https://${langSubdomain + medicareSubdomain}medicare.gov`

  const medicareLogoClickEventOptions: Event = {
    text: 'Medicare.gov',
    authenticated: isLoggedIn,
    targetLocation: medicareUrl,
    category: Categories.Logo,
    activity: 'Link Click',
    url: window.location.href,
    language: i18n.language,
    title: document.title,
    sendToTealium: true,
    sendToCoreAPI: true,
    isMessageCenter: false
  }

  const wrapperClasses = classNames(
    'ch-c-gov-and-menu-wrapper__wrapper',
    `ch-c-gov-and-menu-wrapper__wrapper--${i18n.language}`
  )

  return (
    <header>
      <GovBanner languageToggleLink={languageToggleLink} isLoggedIn={isLoggedIn} />
      <div className={wrapperClasses}>
        <a
          className='nav-menu-button ds-u-display--flex ds-u-align-items--center'
          href={medicareUrl}
          onClick={() => events.publish(medicareLogoClickEventOptions)}
        >
          <MedicareLogo />
        </a>
        <div className='ds-u-display--flex ds-u-align-items--center'>
          {children}
        </div>
      </div>
    </header>
  )
}
